"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var is_array_1 = require("./is-array");
function each(obj, callback) {
    var value;
    var i = 0;
    if (is_array_1.default(obj)) {
        var length_1 = obj.length;
        for (value = obj[0]; i < length_1 && false !== callback.call(value, value, i, obj); value = obj[++i]) {
            // tslint-ignore
        }
    }
    else {
        for (var name_1 in obj) {
            if (callback.call(obj[name_1], obj[name_1], name_1, obj) === false) {
                break;
            }
        }
    }
    return obj;
}
exports.default = each;
//# sourceMappingURL=each.js.map